import React from 'react';
import { Page, View, Text, Image, StyleSheet } from '@react-pdf/renderer';

const DEFAULT_LOGO = 'https://i.postimg.cc/QVPV9d0x/Full-name-logo-blue.png';

interface DetailedFindingsCoverPageProps {
  documentNumber?: string;
  branding_logo?: string;
  sectionId?: string;
}

const DetailedFindingsCoverPage: React.FC<DetailedFindingsCoverPageProps> = ({ documentNumber, branding_logo, sectionId }) => (
  <Page size="A4" id={sectionId} style={{
    flexDirection: 'column',
    backgroundColor: '#ffffff',
    fontFamily: 'Helvetica',
    fontSize: 10,
    position: 'relative',
  }}>
    {/* Main Content - Centered */}
    <View style={{
      flex: 1,
      justifyContent: 'center',
      alignItems: 'center',
      paddingHorizontal: 60,
    }}>
      {/* Large Logo */}
      <Image
        src={branding_logo ? branding_logo : DEFAULT_LOGO}
        style={{ width: 200, height: 200, objectFit: 'contain', marginBottom: 80 }}
      />

      {/* Simple Divider Line */}
      <View style={{
        width: 100,
        height: 3,
        backgroundColor: '#1e40af',
        marginBottom: 50,
      }} />

      {/* Main Title - Clean and Bold */}
      <Text style={{
        fontSize: 36,
        fontWeight: 'bold',
        color: '#1e40af',
        letterSpacing: 4,
        textAlign: 'center',
      }}>
        DETAILED FINDINGS
      </Text>
    </View>

    {/* Footer */}
    <View style={styles.footer} fixed>
      <Text style={styles.footerLeft}>{documentNumber || 'Document Number'}</Text>
      <Text style={styles.footerRight} render={({ pageNumber, totalPages }) => `${pageNumber} / ${totalPages}`} />
    </View>
  </Page>
);

const styles = StyleSheet.create({
  footer: {
    position: 'absolute',
    bottom: 30,
    left: 0,
    right: 0,
    fontSize: 10,
    color: 'grey',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingHorizontal: 24,
  },
  footerLeft: {
    textAlign: 'left',
    flex: 1,
  },
  footerRight: {
    textAlign: 'right',
    flex: 1,
  },
});

export default DetailedFindingsCoverPage; 